<div class="loading-shade" *ngIf="isLoadingResults"> <!--  || isRateLimitReached"  -->
	<mat-spinner diameter="80" *ngIf="isLoadingResults"></mat-spinner>
</div>
<div class="row">
	<mat-card-title>
		<span style="padding-left:10px;margin-top:5px;font-size:21px;">Schools</span>
	</mat-card-title>
</div>
<div class="row card-container">
	<div class="cardSearchBy">
		<app-search-by-layer (onSearchParmEvent)="onSearchParmEvent($event)" (onResetEvent)="onResetMe()" #child2>
		</app-search-by-layer>
	</div>
	<div class="cardLocation">
		<app-search-location-layer (eventEmitterSchoolDistrict)="districtsInputSelected($event)"
			(eventEmitterCounty)="countiesInputSelected($event)" (eventEmitterRegioncode)="regionsInputSelected($event)"
			#child6></app-search-location-layer>
	</div>
</div>
<div class="row"><!-- style="min-width:580px;" [widthPercent]=90  -->
	<app-msin-mat-table [dataSource]="dataSource" 
		[searchFilter]="searchFilter"
		[columnList]="['selectView','REGIONS.CODE','COUNTy.COUNTY_CODE','DISTRICT','NAME', 'STREET_1', 'Phone', 'cdscODE', 'SCHOOL_STATUS.SCHOOL_STATUS_TYPES_ID']"
		[spacingTop]=20 [showViewIcon]="true" [canClearFilter]="true" [filterPlaceholder]="filterPlaceholder"
		(onIsLoadingResultsEvent)="onIsLoadingResultsEvent($event)" (onRegionChangeEvent)="onRegionChangeEvent($event)"
		[isLoadingResults]="false" (onSearchErrorEvent)="catchSearchError($event)" [showPagination]="true" #child>
	</app-msin-mat-table> <!-- [searchParm]="routeGuardService.searchCriterias"-->
	<!--[headerColor]="blue" -->
</div>